import React, { useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
} from "react-share";
import { FaShareAlt, FaInstagram } from "react-icons/fa";
import "./CollapsibleShare.css";
import { useDropdown } from "hooks/useDropDown";

const CollapsibleShare = () => {
  const shareUrl = window.location.href;
  const {
    elementRef: shareButtonRef,
    expanded: shareButtonIsOpen,
    setExpanded: setShareButtonIsOpen,
    triggerRef: shareButtonTriggerRef,
  } = useDropdown();

  return (
    <div className="share-container">
      <button
        className="share-button"
        onClick={() => setShareButtonIsOpen(!shareButtonIsOpen)}
        ref={shareButtonTriggerRef}
      >
        <FaShareAlt />
      </button>

      {shareButtonIsOpen && (
        <div className="share-icons" ref={shareButtonRef}>
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>

          <TwitterShareButton url={shareUrl}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>

          <WhatsappShareButton url={shareUrl}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>

          {/* Instagram link (not a share button) */}
          {/* <a
            className="instagram-link"
            href={instagramProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={32} />
          </a> */}
        </div>
      )}
    </div>
  );
};

export default CollapsibleShare;
